import { Button } from '@/components/ui/button';
import { QuestionProps } from '@/types/questionnaire';
import { useDeleteQuestion } from '../hooks/useDeleteQuestion';

export function DeleteQuestionDialog({
  question,
  onClose,
  onSuccess,
}: {
  question: QuestionProps;
  onClose: () => void;
  onSuccess?: () => void;
}) {
  const { deleteQuestionMutation } = useDeleteQuestion({
    question,
    onClose,
    onSuccess,
  });

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete{' '}
          <strong className="text-foreground">{question.label}</strong>?
        </p>
        <p className="text-sm text-muted-foreground">
          This action cannot be undone and will permanently remove this question
          from the application.
        </p>
      </div>

      <div className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={() => deleteQuestionMutation.mutate()}
          disabled={deleteQuestionMutation.isPending}
        >
          {deleteQuestionMutation.isPending ? 'Deleting...' : 'Delete Question'}
        </Button>
      </div>
    </div>
  );
}
